module.exports = __webpack_public_path__ + "img/mynextpay-white.300711b3.svg";